import React from 'react';
import { Query } from 'react-apollo';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getFeature } from '../../graphql/queries/feature';
import Header from '../common/Header';

const Feature = () => {
  let { id } = useParams();
  const { t } = useTranslation();

  return (
    <div className="list">
      <Header
        title="features.show.title"
        linkTo={`/admin/features/${id}/edit`}
        buttonLabel="shared.edit"
      />
      <Query {...getFeature(id)}>
        {({ loading, data }) => {
          if (loading) return <div className="lds-dual-ring" />;
          if (data) {
            const { feature } = data;

            return (
              <div className="common-show">
                <div className="grid">
                  <div className="col-12">
                    <div className="common-show__infos">
                      <div className="col-12">
                        <div className="common-show__infos--field">
                          {t('features.attributes.name')}
                        </div>
                        <div className="common-show__infos--value">{feature.name}</div>
                        <div className="common-show__infos--field">
                          {t('features.attributes.icon')}
                        </div>
                        <div className="common-show__infos--value">{feature.icon}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
          return null;
        }}
      </Query>
    </div>
  );
};

export default Feature;
